import { useState } from "react";
import { toast } from "react-toastify";
import { fmtPct, manualInputBtn } from "../../../consts/demandplanning";

export const CappedPctInputForecastDemand = ({ 
    value, 
    maxAllowed, 
    onSave, 
    nullable, 
    onClear, 
    placeholder 
}) => {

    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");

    const startEdit = () => {
        const base = value == null || Number.isNaN(Number(value)) ? 0 : Number(value);
        const pct = (base * 100).toFixed(2).replace(/\.00$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
        setDraft(pct);
        setEditing(true);
    };

    const setDigitsOnly = (raw) => {
        const digits = String(raw).replace(/[^0-9.,]/g, "");
        const normalized = digits.replace(",", ".");
        const [intPart = "", ...decimalParts] = normalized.split(".");
        const decimal = decimalParts.join("").slice(0, 2);
        const result = decimalParts.length
            ? `${intPart},${decimal}`
            : intPart;
        setDraft(result);
    };

    const commit = () => {
        if (String(draft).trim() === "") {
            setEditing(false);
            return;
        }
        const normalized = String(draft).replace(",", ".");
        const num = Number.parseFloat(normalized);
        const maxPctNum = maxAllowed * 100;
        if (!Number.isFinite(num) || num < 0 || num > maxPctNum + 0.005) {
            const maxPctLabel = maxPctNum.toFixed(2).replace(/\.00$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
            toast.error(`Enter a value between 0 and ${maxPctLabel}`, { position: "bottom-right" });
            setEditing(false);
            return;
        }
        const asDecimal = num / 100;
        if (asDecimal > maxAllowed + 0.00005) {
            const maxPct = maxPctNum.toFixed(2).replace(/\.00$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
            toast.error(`Maximum allowed is ${maxPct}%`, { position: "bottom-right" });
            setEditing(false);
            return;
        }
        onSave(Math.min(asDecimal, maxAllowed));
        setEditing(false);
    };

    if (editing) {
        return (
            <div className="flex items-center gap-1">
                <input
                    autoFocus
                    type="text"
                    inputMode="decimal"
                    value={draft}
                    onChange={(e) => setDigitsOnly(e.target.value)}
                    onFocus={(e) => {
                        if (draft === "0") {
                            e.target.select();
                        }
                    }}
                    onBlur={commit}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") commit();
                        if (e.key === "Escape") setEditing(false);
                    }}
                    className="w-16 mb-[1px] px-2 py-0.5 text-[12px] border border-gray-300 rounded-[4px] bg-white text-gray-900 outline-none h-[25px]"
                />
                <span className="text-[11px] text-gray-500">%</span>
            </div>
        );
    }

    return (
        <button type="button" onClick={startEdit} className={`${manualInputBtn} group px-2 py-0.5 h-[25px]`} title="Click to edit">
            <span className="text-[12px] text-gray-900">
                {placeholder && (value == null || value === 0)
                    ? placeholder
                    : fmtPct(value == null ? 0 : value)}
            </span>
            {nullable && onClear && value != null && value !== 0 && (
                <span
                    role="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClear();
                    }}
                    className="text-gray-400 hover:text-gray-600 text-[10px] ml-1"
                    title="Clear override"
                >
                    ×
                </span>
            )}
        </button>
    );
}
